import React, { Component } from "react";
import { DataGrid, GridColumn, Panel, ComboBox } from "rc-easyui";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import { API_URL } from "../../../constants";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";

const axios = require("axios");

export default class ViewUser extends Component {
	static propTypes = {
		selectedRow: PropTypes.object,
		OnEditClick: PropTypes.func,
		onSelectionChange: PropTypes.func,
		permissions: PropTypes.array,
	};

	constructor(props) {
		super(props);
		this.refereshData = this.refereshData.bind(this);
		this.onPageChange = this.onPageChange.bind(this);
		this.state = {
			data: [],
			pageOptions: {},
			search: { username: "", status: true },
		};
	}

	componentDidMount() {
		this.setState(
			{
				pageOptions: {
					loading: true,

					pageOptions: {
						pageNumber: 1,
						pageSize: 10,
						layout: [
							"list",
							"sep",
							"first",
							"prev",
							"next",
							"last",
							"sep",
							"refresh",
							"sep",
							"manual",
							"info",
						],
					},
				},
			},
			() => {
				this.refereshData();
			}
		);
	}

	async refereshData() {
		const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
		const { username, status } = this.state.search;

		var access_token = getCookie("access_token");
		var token_type = getCookie("token_type");
		let axiosConfig = {
			headers: {
				authorization: token_type + " " + access_token,
				"Content-Type": "application/json",
			},
		};
		var url =
			API_URL +
			"api/userspagination?row=" +
			pageSize +
			"&page=" +
			pageNumber +
			"&username=" +
			username +
			"&status=" +
			status;

		this.setState({
			pageOptions: {
				pageOptions: {
					...this.state.pageOptions.pageOptions,
				},
				loading: true,
			},
		});
		if (access_token != null) {
			axios
				.get(url, axiosConfig)
				.then((response) => {
					var data = response.data.rows;
					data.map(d=>{
						d.enabled==true? d.enabled='Active':d.enabled='Inactive'
					})
					var total = response.data.total;
					if (response.status === 200) {
						this.setState({
							data: data,
							pageOptions: {
								pageOptions: {
									pageSize: Math.min(10, 50, 30, 100, total),
									total: total,
									pageList: [10, 50, 30, 100, total].sort(function (a, b) {
										return a - b;
									}),
									...this.state.pageOptions.pageOptions,
								},
								loading: false,
							},
						});
					} else {
						this.setState({
							pageOptions: {
								pageOptions: { ...this.state.pageOptions.pageOptions },
								loading: false,
							},
						});
					}
				})
				.catch((error) => {
					this.setState({
						pageOptions: {
							pageOptions: {
								...this.state.pageOptions.pageOptions,
							},
							loading: false,
						},
					});
				});
		} else {
			//Access Token Expired.
			//Generate new Access Token using Refresh Token.
			const resp = await getAccessToken();
			if (resp) {
				this.refereshData();
			}
		}
	}

	onPageChange(event) {
		delete event["refresh"];
		delete event["filterRules"];
		event["pageNumber"] = 1;
		this.setState(
			{
				pageOptions: {
					pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
					loading: true,
				},
			},
			function () {
				this.refereshData();
			}
		);
	}

	handleChange(name, value) {
		let search = Object.assign({}, this.state.search);
		search[name] = value;
		this.setState({ search: search });
	}

	render() {
		const { status, username } = this.state.search;
		return (
			<div>
				<Panel
					title="User List"
					bodyStyle={{ padding: 0 }}
					style={{ height: 567 }}
				>
					<div id="toolbar" className="datagrid-toolbar">
						{this.props.permissions.includes("user-registration-edit") ? (
							<span
								className="easyui-linkbutton l-btn l-btn-small l-btn-plain"
								iconcls="icon-edit"
								plain="true"
								onClick={this.props.OnEditClick}
								group=""
								id=""
							>
								<span className="l-btn-left l-btn-icon-left">
									<span className="l-btn-text">Edit</span>
									<span className="l-btn-icon icon-edit">&nbsp;</span>
								</span>
							</span>
						) : (
							""
						)}
						<input
							type="text"
							placeholder="Username"
							className="custom_input"
							onChange={(e) => this.handleChange(e.target.name, e.target.value)}
							name="username"
							id=""
						/>
						&nbsp;&nbsp;
						<ComboBox
							data={[
								{ value: true, text: "Active" },
								{ value: false, text: "Inactive" },
							]}
							editable={false}
							value={status}
							onChange={(e) => this.handleChange("status", e)}
							style={{ width: 150 }}
						></ComboBox>
						&nbsp;&nbsp;&nbsp;
						<Button
							type="button"
							color="primary"
							data-testid="loginbtn"
							size="sm"
							onClick={this.refereshData}
						>
							Search
						</Button>
					</div>
					<DataGrid
						data={this.state.data}
						style={{ height: 500 }}
						selectionMode="single"
						{...this.state.pageOptions}
						pagination
						{...this.props.selectedRow}
						onSelectionChange={(selection) =>
							this.props.onSelectionChange(selection)
						}
						onPageChange={this.onPageChange}
					>
						<GridColumn
							field="rn"
							align="center"
							width="30px"
							cellCss="datagrid-td-rownumber"
							render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
						/>

						<GridColumn field="fullname" title="Full Name"></GridColumn>
						<GridColumn field="contactno" title="Contact"></GridColumn>
						<GridColumn field="username" title="Username"></GridColumn>
						<GridColumn field="rolename" title="User Group"></GridColumn>
						<GridColumn
							width={110}
							field="enabled"
							title="Status"
							// render={({ row }) => <span>{row ? "Active" : "Inactive"}</span>}
						></GridColumn>
					</DataGrid>
				</Panel>
			</div>
		);
	}
}
